import MobileSliderPagesCloseButton from "./MobileSliderPagesCloseButton.jsx";
import {
    MobileSliderPagesHeaderCloseButtonContainerStyled, MobileSliderPagesHeaderContentStyled,
    MobileSliderPagesHeaderStyled
} from "./styled/MobileSliderPagesStyled.js";
import classnames from "classnames";

function MobileSliderPagesHeader(props) {
    const {children, closeButtonPosition = "left", ...rest} = props;
    return <MobileSliderPagesHeaderStyled>
        <MobileSliderPagesHeaderCloseButtonContainerStyled className={classnames({
            "left": closeButtonPosition === "left",
            "right": closeButtonPosition === "right",
        })}>
            <MobileSliderPagesCloseButton {...rest}/>
        </MobileSliderPagesHeaderCloseButtonContainerStyled>
        <MobileSliderPagesHeaderContentStyled>
            {children}
        </MobileSliderPagesHeaderContentStyled>
    </MobileSliderPagesHeaderStyled>
}

export default MobileSliderPagesHeader;
